import {http} from "@/api/HttpClient.ts";
import {Pageable, PageModel} from "@/api/Paging.ts";
import Campaign from "@/campaigns/model/Campaign.ts";

export type SaveCampaignRequest = {
    id: string;
    title: string;
    description: string;
    imageId: string;
    slug: string;
};

export async function searchCampaigns(pageable: Pageable, params?: {title?: string}): Promise<PageModel<Campaign>> {
    const res = await http.get<PageModel<Campaign>>("/campaigns", {params: {...pageable, ...params}});
    return res.data;
}

export async function getCampaignById(id: string): Promise<Campaign> {
    const res = await http.get<Campaign>(`/campaigns/${id}`);
    return res.data;
}

export async function getCampaignBySlug(slug: string): Promise<Campaign> {
    const res = await http.get<Campaign>(`/campaigns/by-slug/${encodeURIComponent(slug)}`);
    return res.data;
}

export async function saveCampaign(request: SaveCampaignRequest): Promise<Campaign> {
    const res = await http.post<Campaign>("/campaigns", request);
    return res.data;
}

export async function deleteCampaign(id: string): Promise<void> {
    await http.delete(`/campaigns/${id}`);
}
